import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  let history = useHistory();
  let location = useLocation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.params && location.params.id) {
      getAuthor();
    } else {
      history.push('/author');
    }
  }, []);

  const back = () => {
    history.goBack();
  };

  const getAuthor = () => {
    AxiosInstance.get('/author/' + location.params.id)
      .then((response) => {
        let inputValues = {
          name: response.data.name,
          image: response.data.image,
          display: response.data.display,
        };
        updateFormState(inputValues);
      })
      .catch((error) => {
        Swal.fire(t('author.ERROR_GET_AUTHOR'), '', 'error');
        // history.push('/author');
      });
  };

  const updateAuthor = () => {
    const formData = new FormData();
    formData.append('name', formState.inputValues.name);
    formData.append('display', formState.inputValues.display);
    if (formState.inputValues.image instanceof File) {
      formData.append('image', formState.inputValues.image);
    }

    setLoading(true);
    AxiosInstance({
      method: 'patch',
      url: '/author/' + location.params.id,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        Swal.fire(t('author.SUCCESS_UPDATE_AUTHOR'), '', 'success');
        setLoading(false);
      })
      .catch((error) => {
        if (error.status === 400) {
          handleErrorsServer(error.data.message);
        } else Swal.fire(t('author.ERROR_UPDATE_AUTHOR'), '', 'error');
        setLoading(false);
      });
  };

  const inputValues = {
    name: { value: '', validate: { required: true } },
    display: { value: false, validate: { required: true } },
    image: { value: '', validate: { required: false } },
  };

  const { formState, submitHandler, updateFormState, field, handleErrorsServer } = FormState(inputValues, updateAuthor);

  return {
    submitHandler,
    back,
    loading,
    field,
  };
};

export default useForm;
